export default "__VITE_ASSET__DextwZS8__"